import React, {useEffect, useState} from 'react'
import {Box, Typography} from '@mui/material'
import Loading from '../../components/loading.component'
import {getSearcherDetails} from '../../services/user.service'

const VendorProfile: React.FC<{ searchCompanyId: number }> = ({searchCompanyId }) => {

  const [loading, setLoading] = useState(false)
  const [userData, setUserData] = useState({
    username: '',
    role: '',
    email: '',
    company: '',
    country: '',
    addressLine1: '',
    phone: '',
    city: '',
    state: '',
    zipcode: '',
  })

  useEffect(() => {
    const fetchSearcherDetails = async () => {
      if (searchCompanyId) {
        setLoading(true)
        try {
          const searcher = await getSearcherDetails(searchCompanyId)
          const primaryAdmin = searcher.Users.find((user: any) => user.PrimaryAdmin === "1");

          setUserData({
            username: primaryAdmin ? primaryAdmin.Username : '',
            role: "Admin",
            email: searcher.Company?.Email || '',
            company: searcher.Company?.Company || '',
            country: searcher.Company?.Country || '',
            addressLine1: searcher.Company?.Address1 || '',
            phone: searcher.Company?.Phone || '',
            city: searcher.Company?.City || '',
            state: searcher.Company?.State || '',
            zipcode: searcher.Company?.Zip || '',
          })
        } catch (error) {
          console.error('Failed to fetch user:', error)
        } finally {
          setLoading(false)
        }
      }
    }
    fetchSearcherDetails()
  }, [searchCompanyId])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Box sx={{position: 'relative'}}>
          <Box sx={{display: 'flex', flexWrap: 'wrap'}}>
            <Box mb={2.5} width='20%'>
              <Typography style={{fontWeight: 'bold', fontSize: '1.2rem'}}>Username</Typography>
              <Typography variant='body1' sx={{fontSize: '1.2rem'}}>
                {userData?.username || 'N/A'}
              </Typography>
            </Box>
            <Box mb={2.5} width='20%'>
              <Typography style={{fontWeight: 'bold', fontSize: '1.2rem'}}>Role</Typography>
              <Typography variant='body1' sx={{fontSize: '1.2rem'}}>
                {userData?.role || 'N/A'}
              </Typography>
            </Box>
            <Box width='100%'></Box>
            <Box mb={2.5} width='20%'>
              <Typography style={{fontWeight: 'bold', fontSize: '1.2rem'}}>Email</Typography>
              <Typography variant='body1' sx={{fontSize: '1.2rem'}}>
                {userData?.email}
              </Typography>
            </Box>
            <Box width='100%'></Box>
            <Box mb={2.5} width='20%'>
              <Typography style={{fontWeight: 'bold', fontSize: '1.2rem'}}>Company Name</Typography>
              <Typography variant='body1' sx={{fontSize: '1.2rem'}}>
                {userData?.company || 'N/A'}
              </Typography>
            </Box>
          </Box>
          <Box sx={{borderTop: '1px solid #e0e0e0', my: 4}} />

          <Box>
            <Typography style={{fontWeight: 'bold', fontSize: '1.2rem', marginBottom: '15px'}}>
              Company Address
            </Typography>
            <Box mb={2.5} width='40%'>
              <Typography style={{fontWeight: 'bold', fontSize: '1.2rem'}}>Country</Typography>
              <Typography variant='body1' sx={{fontSize: '1.2rem'}}>
                {userData?.country || 'N/A'}
              </Typography>
            </Box>

            <Box display='flex' gap={1} width='40%'>
              <div className='col-md-9'>
                <Box mb={2.5} width='40%'>
                  <Typography style={{fontWeight: 'bold', fontSize: '1.2rem'}}>
                    Address line1
                  </Typography>
                  <Typography variant='body1' sx={{fontSize: '1.2rem'}}>
                    {userData?.addressLine1 || 'N/A'}
                  </Typography>
                </Box>
              </div>
              <div className='col-md-9'>
                <Box mb={2.5} width='40%'>
                  <Typography style={{fontWeight: 'bold', fontSize: '1.2rem'}}>
                    Phone Number
                  </Typography>
                  <Typography variant='body1' sx={{fontSize: '1.2rem'}}>
                    {userData?.phone || 'N/A'}
                  </Typography>
                </Box>
              </div>
            </Box>
            <Box display='flex' gap={1} width='40%'>
              <div className='col-md-9'>
                <Box mb={2.5} width='40%'>
                  <Typography style={{fontWeight: 'bold', fontSize: '1.2rem'}}>City</Typography>
                  <Typography variant='body1' sx={{fontSize: '1.2rem'}}>
                    {userData?.city || 'N/A'}
                  </Typography>
                </Box>
              </div>
              <div className='col-md-9'>
                <Box mb={2.5} width='40%'>
                  <Typography style={{fontWeight: 'bold', fontSize: '1.2rem'}}>State</Typography>
                  <Typography variant='body1' sx={{fontSize: '1.2rem'}}>
                    {userData?.state || 'N/A'}
                  </Typography>
                </Box>
              </div>
            </Box>

            <Box width='40%'>
              <div className='col-md-9'>
                <Box mb={2.5} width='20%'>
                  <Typography style={{fontWeight: 'bold', fontSize: '1.2rem'}}>Zip code</Typography>
                  <Typography variant='body1' sx={{fontSize: '1.2rem'}}>
                    {userData?.zipcode || 'N/A'}
                  </Typography>
                </Box>
              </div>
            </Box>
          </Box>
        </Box>
      )}
    </>
  )
}

export {VendorProfile}
